const hashParse = location.pathname.split('/u/bmmain/')
const hashRoute = hashParse && hashParse[1]
const skeletons = [
  {
    route: /^helpsale\/correlate?$/,
    component: () => import('./index.css')
  },
  {
    route: /^helpsale\/correlate-[A-Za-z]plan-index?$/,
    component: () => import('./index.css')
  },
  {
    route: /^helpsale\/correlate-[A-Za-z]plan-second?$/,
    component: () => import('./index.css')
  },
  {
    route: /^helpsale\/index?$/,
    component: () => import('./index.css')
  },
  {
    route: /.+/,
    component: () => import('./default.css')
  }
]
if (hashRoute) {
  const skeleton = skeletons.find(({ route }) => route.test(hashRoute))
  if (skeleton) {
    skeleton.component()
  }
}
